import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { assessorAssignmentsActions } from '../actions/assessor-assignments.actions';
import { AssessorAssignmentsValue } from '../models';
import {
    selectAssignments,
    selectCourses,
    selectCoursesLoaded,
    selectCoursesLoading,
    selectError,
    selectLoaded,
    selectLoading,
    selectPackages,
    selectPackagesLoaded,
    selectPackagesLoading,
    selectSaved,
    selectSaving,
    selectSchools,
    selectSchoolsLoaded,
    selectSchoolsLoading,
} from '../selectors/assessor-assignments.selector';

@Injectable({
    providedIn: 'root',
})
export class AssessorAssignmentsFacade {
    private readonly store = inject(Store);

    readonly assignments = this.store.selectSignal(selectAssignments);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    readonly schools = this.store.selectSignal(selectSchools);
    readonly schoolsLoaded = this.store.selectSignal(selectSchoolsLoaded);
    readonly schoolsLoading = this.store.selectSignal(selectSchoolsLoading);

    readonly courses = this.store.selectSignal(selectCourses);
    readonly coursesLoaded = this.store.selectSignal(selectCoursesLoaded);
    readonly coursesLoading = this.store.selectSignal(selectCoursesLoading);

    readonly packages = this.store.selectSignal(selectPackages);
    readonly packagesLoaded = this.store.selectSignal(selectPackagesLoaded);
    readonly packagesLoading = this.store.selectSignal(selectPackagesLoading);

    getAssignments(userId: string): void {
        this.store.dispatch(assessorAssignmentsActions.getAssignments({ userId }));
    }

    updateAssignments(userId: string, value: AssessorAssignmentsValue): void {
        this.store.dispatch(assessorAssignmentsActions.updateAssignments({ userId, value }));
    }

    getSchools(organisationIds: string[]): void {
        this.store.dispatch(assessorAssignmentsActions.getSchools({ organisationIds }));
    }

    getCourses(schoolIds: string[]): void {
        this.store.dispatch(assessorAssignmentsActions.getCourses({ schoolIds }));
    }

    getPackages(schoolIds: string[]): void {
        this.store.dispatch(assessorAssignmentsActions.getPackages({ schoolIds }));
    }

    clear(): void {
        this.store.dispatch(assessorAssignmentsActions.clear());
    }
}
